<template lang="html">

    <div data="documentacion" class="cv-part">
        <h2 class="title no-edit">Expectativas salariales</h2>
        <select v-model="salario" @change="editSalario(salario)">
          <option value="0">Salario mínimo deseado</option>
          <option :value="key" v-for="(salario,key) in dominios.salario">{{salario}}</option>
        </select>
        
      </div>

</template>

<script lang="js">
  
  import {mapGetters,mapActions} from 'vuex';

  export default  {
    name: 'salario',
    props : ['info'],
    mounted(){
      this.salario = this.info;
    },
    data(){
      return{
        salario : 0
      }
    },
    computed:{
      ...mapGetters({
        dominios : 'getDominios'
      })
    },
    methods : {
      ...mapActions(['editSalario'])
    }
}
</script>

<style scoped lang="scss">

  select{
    width:100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/mi-cv/salario.vue